import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const GoDialog = ({ title, content, open, positive, negative, handleClose }) => {
    return (
        <Dialog
            open={open}
            onClose={() => handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {negative !== undefined && <Button onClick={() => handleClose(false)}>{negative}</Button>}
                {positive !== undefined && <Button onClick={() => handleClose(true)} autoFocus>
                    {positive}
                </Button>}
            </DialogActions>
        </Dialog>
    )
};

export default GoDialog;